import { render, staticRenderFns } from "./RegisterRefiDigital.vue?vue&type=template&id=c0af18ca&scoped=true&"
import script from "./RegisterRefiDigital.vue?vue&type=script&lang=ts&"
export * from "./RegisterRefiDigital.vue?vue&type=script&lang=ts&"
import style0 from "./RegisterRefiDigital.vue?vue&type=style&index=0&id=c0af18ca&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "c0af18ca",
  null
  
)

export default component.exports